import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const create = (content) => request(
  {
    url: API.COORDINATORE,
    method: 'POST',
    data: content,
  });

const put = (content) => request(
  {
    url: `${API.COORDINATORE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const getById = (id) => request(
  {
    url: `${API.COORDINATORE}/${id}`,
    method: 'GET',
  });

const CoordinatoreService = {
  create,
  getById,
  put,
};

export default CoordinatoreService;



// WEBPACK FOOTER //
// ./app/shared/services/api/coordinatore/index.js